export default "__VITE_ASSET__e5684e40__"